$(function ($) {
    /*
     * Translated default messages for the jQuery validation plugin.
     * Locale: LT (Lithuanian; lietuvių kalba)
     */
    $.extend($.validator.messages, {
        required: 'Šis laukas yra privalomas.',
        remote: 'Pataisykite šį lauką.',
        email: 'Įveskite teisingą elektroninio pašto adresą.',
        url: 'Įveskite teisingą nuorodą.',
        date: 'Įveskite teisingą datą.',
        dateISO: 'Įveskite teisingą datą (YYYY-MM-DD).',
        number: 'Įveskite teisingą skaičių.',
        digits: 'Naudokite tik skaitmenis.',
        creditcard: 'Įveskite teisingą kreditinės kortelės numerį.',
        equalTo: 'Įveskite tą pačią reikšmę dar kartą.',
        extension: 'Įveskite reikšmę su teisingu plėtiniu.',
        maxlength: $.validator.format('Įveskite ne daugiau kaip {0} simbolių.'),
        minlength: $.validator.format('Įveskite bent {0} simbolius.'),
        rangelength: $.validator.format('Įveskite reikšmes, kurių ilgis būtų nuo {0} iki {1} simbolių.'),
        range: $.validator.format('Įveskite reikšmę intervale nuo {0} iki {1}.'),
        max: $.validator.format('Įveskite reikšmę mažesnę arba lygią {0}.'),
        min: $.validator.format('Įveskite reikšmę didesnę arba lygią {0}.')
    });
});
